import React from "react";
import { Card } from "../modules/Settings/PackSizes";

export function PackSizesCardPage(props) {
  return <Card {...props} />;
}
